//在此处编写调用授权等基本平台接口
class cb_api {
    constructor(axiosFactory) {
        this.$http = axiosFactory;
    }
    http() {
        return this.$http;
    };
    get(url, cb) {
        this.$http.get(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });;
    }
    gets(url, data, cb) {
        this.$http.get(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    post(url, data, cb) {
        this.$http.post(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    posts(url, cb) {
        this.$http.post(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    put(url, data, cb) {
        this.$http.put(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    puts(url, cb) {
        this.$http.put(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    delete(url, data, cb) {
        this.$http.delete(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    deletes(url, cb) {
        this.$http.delete(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }

    //------------------------------------------------------------
    //上传简历文件
    postUploadToPath(formData, cb) {
        this.post(`/upload/toFolder`, formData, cb)
    }
}
class apiFactory {
    constructor() {

    }
    createApi(axios) {
        return new cb_api(axios)
    }
}
export default new apiFactory();